<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <h3>{{ "i18n.base.set-password.header" | translate }}</h3>
    <div class="e-card">
      <div class="e-card-content">
        @if (areParametersValid && !passwordSetSuccess) {
          <form id="setPasswordForm" [formGroup]="setPasswordForm" autocomplete="on">
            <div class="form-group">
              <label for="password">{{ "i18n.base.set-password.password" | translate }}</label>
              <app-password-input inputId="password"
                                  name="password"
                                  autocomplete="new-password"
                                  formControlName="password">
              </app-password-input>
              <app-error-messages [control]="formFields.password"></app-error-messages>
            </div>
            <div class="form-group">
              <label for="passwordConfirm">{{ "i18n.base.set-password.passwordConfirm" | translate }}</label>
              <app-password-input inputId="passwordConfirm"
                                  name="passwordConfirm"
                                  autocomplete="new-password"
                                  formControlName="passwordConfirm">
              </app-password-input>
              <app-error-messages [control]="formFields.passwordConfirm"></app-error-messages>
            </div>
            <div class="d-flex justify-content-end">
              <button type="submit" class="btn btn-primary" (click)="setPassword()" [disabled]="!setPasswordForm.valid">
                {{ "i18n.base.set-password.setPassword" | translate }}
              </button>
            </div>
          </form>
        }
        @if (!areParametersValid) {
          <div> {{ "i18n.base.set-password.invalid-link" | translate }} </div>
        }
        @if (passwordSetSuccess) {
          <div>
            <div>
              <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.set-password.success-message" | translate }}</p>
              <p class="success-message">{{autoRedirectMessage | translate}}</p>
              <a [routerLink]="[loginRoute]">{{ 'i18n.core.navigation.login' | translate }}</a>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
